import * as React from "react";
import { UitkLink } from "uitk-react-link";
import { useDialog } from "@shared-ui/dialog-context";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

interface LinkListViewProps {
  text: string;
  children: React.ReactNode;
}

export const LinkListView: React.FC<LinkListViewProps> = (props) => {
  const { text, children } = props;
  const [, dialogActions, TripCostDialogWrapper] = useDialog("tripCostDialog");

  return (
    <div className="LinkListView">
      <UitkLink>
        <TrackedLink moduleName="tripCostEstimator" rfrr="links-view-list" href="#" onClick={dialogActions.openDialog}>
          {text}
        </TrackedLink>
      </UitkLink>
      <TripCostDialogWrapper>{children}</TripCostDialogWrapper>
    </div>
  );
};

export default LinkListView;
